import API from "./api";

// Register
export const registerUser = (data) => {
  return API.post("/register/register", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// View own profile
export const getMyProfile = () => {
  return API.get("/register/me");
};
  
// Admin only - get all employees
export const getAllEmployees = (params) => {
  return API.get("/register/all", { params });
};

// Admin only - get employee by id
export const getEmployeeById = (id) => {
  console.log("Sending ID:", id);
  return API.get(`/register/${id}`);
};

// Admin only - update employee
export const updateEmployee = (id, data) => {
  return API.post(`/register/update/${id}`, data);
};

// Admin only - delete employee
export const deleteEmployee = (id) => {
  return API.delete(`/register/delete/${id}`);
};

// Get pending employees
export const getPendingEmployees = () => {
  return API.get("/register/pending");
};

// Approve employee
export const approveEmployee = (id) => {
  return API.post(`/register/approve/${id}`);
};

// Reject employee
export const rejectEmployee = (id, data) => {
  return API.post(`/register/reject/${id}`, data);
};

export const getDashboardStats = () => {
  return API.get("/register/dashboard");
};

export const exportEmployees = (params) => {
  return API.get("/register/export", {
    params,
    responseType: "blob",
  });
};


export const toggleEmployeeStatus = (id) => {
  return API.patch(`/register/toggle-status/${id}`);
};